import React from 'react';
//dls
import { TextField } from '@swiggy-private/dls-web-core/dist/components/TextField';
import { RightActionTypes, TextFieldTypes, } from '@swiggy-private/dls-web-core/dist/components/TextField/types';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
//stores
import useSearchCampaignStore from '@/stores/SearchCampaign';
//constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//styles
import styles from './Filters.module.scss';
const CreatedBy = () => {
    const { createdBy, setCreatedBy } = useSearchCampaignStore((state) => ({
        createdBy: state.createdByFilter.createdBy,
        setCreatedBy: state.createdByFilter.setCreatedBy,
    }));
    const onChange = (value) => {
        setCreatedBy(value);
    };
    return (React.createElement("div", null,
        React.createElement(Text, { className: styles.filterLabel, variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Highest_Emphasis }, "Created By"),
        React.createElement(TextField, { textFieldDetails: {
                value: createdBy,
                type: TextFieldTypes.TEXT,
                name: 'created-by-input',
                label: 'Enter Created By',
                onChange: onChange,
                attrs: { autoComplete: 'off' },
                containerStyle: {
                    marginTop: '12px',
                },
            }, rightActionDetails: [
                {
                    type: RightActionTypes.CLEAR,
                },
            ] })));
};
export default CreatedBy;
